@for (item of repeat(); track item) {
<div class="shimmer">
    @if (multiStrokeWithImage()) {
    <div class="wrapper">
        <div class="image-card animate"></div>
        <div class="stroke animate title"></div>
        <div class="stroke animate link"></div>
        <div class="stroke animate description"></div>
    </div>
    } @if (singleStroke()) {
    <div class="wrapper">
        <div class="stroke animate title"></div>
    </div>
    }
</div>
}